import styled from 'styled-components';
import { em } from 'polished';
import { colors, elevation } from 'core/theme';

export const StyledFilterSelect = styled.div`
    position: relative;

    & > button {
        background-color: ${colors.background};
        border: 1px solid ${colors.hairline};
        color: ${colors.subtleText};
        font-size: 1em;
        min-height: ${em(42)};
        padding: 0.5em 0.5em 0.4em 1em;
        text-align: left;
        width: 100%;

        display: flex;
        align-items: center;
        justify-content: space-between;

        & > * {
            pointer-events: none;
        }

        & > i {
            color: ${colors.subtleText};
        }
    }

    &[aria-expanded="true"] {
        & > button > i {
            transform: scaleY(-1);
        }
    }

    @media print {
      display: inline-block;

      & > button {
        border: 0;
        color: ${colors.black};
        margin-left: 0.5em;
        min-height: 0;
        padding: 0;
        width: auto;

        & > i {
          display: none;
        }
      }
    }
`;

export const ListDrop = styled.ul`
    list-style: none;
    margin: 0;
    padding-left: 0;

    position: absolute;
    bottom: 1px; /* border on border */
    left: 0;
    width: 100%;
    transform: translateY(100%);
    z-index: 100;

    background-color: ${colors.background};
    border: 1px solid ${colors.hairline};
    ${/* box-shadow: ${elevation.Z2}; */''};
    display: ${props => props.open ? 'block' : 'none'};
    padding: 1em 1em 1.5em;
`;

export const StyledFilterItem = styled.li`
    font-size: ${em(14)};

    & + & {
        margin-top: 1em;
    }

    &[aria-disabled="true"] {
        opacity: 0.5;
        pointer-events: none;
    }

    label {
        color: ${colors.subtleText};
    }
`;



// WEBPACK FOOTER //
// ./src/pages/Rezultati/components/FilterSelect/styled.js